/* eslint-disable eqeqeq */
import axios from "axios";

import {
  ACTenglishScoringMatrix,
  ACTmathScoringMatrix,
  ACTreadingScoringMatrix,
  ACTscienceScoringMatrix,
  SATverbalScoringMatrix,
  SATmathScoringMatrix,
  EqualityMatrix,
} from "../components/resultsScoring";

export const BrandColors = {
  brandGreen: "#6AB03D",
  brandDarkGreen: "#477729",
  brandLightGreen: "#BAD7A7",
  brandLightGray: "#D9D9D9",
  brandVeryLightGray: "#f3f3f3",
  brandDarkGray: "#686868",
};

export const CourseFee = 75;

export const StripeKey = process.env.REACT_APP_STRIPE_KEY;


// eslint-disable-next-line no-undef
export const ApiEndpoint = process.env.REACT_APP_API_ENDPOINT;

// eslint-disable-next-line no-undef
export const homeUrl = process.env.REACT_APP_HOME_URL;

// eslint-disable-next-line no-undef
export const imagesUrl = process.env.REACT_APP_IMAGES_URL;

export const pageIds = {
  homepage: "homepage",
  login: "login",
  register: "register",
  register_confirm: "register_confirm",
  register_success: "register_success",
  exam_start: "exam_start",
  section_complete: "section_complete",
  section_end: "section_end",
  exam_complete: "exam_complete",
};

export const checkIfExamComplete = (userData) => {
  let currSection = userData.currentSectionId;
  const sectionLength = userData.examAnswers.length;

  if (currSection >= sectionLength - 2) {
    return true;
  } else {
    return false;
  }
};

export const updateCurrentSection = async (userData) => {
  let temp = { ...userData };
  console.log(temp);
  const SATVerbalMin = 70;
  const SATMathMin = 65;

  const respScore = await axios.post(
    ApiEndpoint + "wp-json/firstchoiceprep/v1/calculateSectionScore",
    {
      token: userData.token,
      sectionId: temp.currentSectionId,
      userid: temp.userid,
    }
  );
  
  if (temp.currentSectionId === 1 && respScore.data.score >= SATVerbalMin) {
    temp.satVerbalLevel = 1;
    await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["satVerbalLevel"],
        values: [1],
      }
    );
  }

  if (temp.currentSectionId === 6 && respScore.data.score >= SATMathMin) {
    temp.satMathLevel = 1;
    await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["satMathLevel"],
        values: [1],
      }
    );
  }

  let currSection = temp.currentSectionId;
  //choose the correct next section...
  if (temp.currentSectionId == 2) {
    temp.currentSectionId = temp.satVerbalLevel == 1 ? 4 : 3;
  } else if (temp.currentSectionId == 7) {
    temp.currentSectionId = temp.satMathLevel == 1 ? 9 : 8;
  } else if (temp.currentSectionId == 3) {
    temp.currentSectionId = 5;
  } else {
    temp.currentSectionId = currSection + 1;
  }

  temp.currentSection = temp.examAnswers[temp.currentSectionId].sectionTitle;
  const nextQuestion =
    temp.examAnswers[temp.currentSectionId].questions[0].questionId;
  temp.showSectionEndScreen = true;
  temp.lastQuestionAnswered = nextQuestion;
  temp.sectionStartTime = null;
  return temp;
};

export const startNewSection = (userData) => {
  let temp = { ...userData };
  temp.sectionStartTime = new Date().getTime();
  return temp;
};

export const updateUserPaidStatus = async (token, userid) => {
  const resp = await axios.post(
    ApiEndpoint + "wp-json/firstchoiceprep/v1/confirmPayment",
    {
      token,
      userid,
    }
  );
  return resp;
};

const formatAnswerResponse = (question, cat = "SAT", index = 0) => {
  const letters = " ABCDE";
  const letters2 = " FGHJK";
  if (question.questionType === "input") {
    return {
      answer: question.userAnswer,
      correct: question.correctAnswer,
      type: question.questionCategory,
    };
  }

  return cat === "SAT"
    ? {
        answer: letters[question.userAnswerIndex],
        correct: letters[question.correctAnswerIndex],
        type: question.questionCategory,
      }
    : index % 2 === 0
    ? {
        answer: letters[question.userAnswerIndex],
        correct: letters[question.correctAnswerIndex],
        type: question.questionCategory,
      }
    : {
        answer: letters2[question.userAnswerIndex],
        correct: letters2[question.correctAnswerIndex],
        type: question.questionCategory,
      };
};

export const formatResultsData = (response) => {
  const satVerbalLevel = { current: null };
  const satMathLevel = { current: null };
  const resp = response.results;
  //get high level stats...
  const actEnglishScore = ACTenglishScoringMatrix[resp[0].correctAnswer];
  const actMathScore = ACTmathScoringMatrix[resp[2].correctAnswer];
  const actReadingScore = ACTreadingScoringMatrix[resp[5].correctAnswer];
  const actScienceScore = ACTscienceScoringMatrix[resp[7].correctAnswer];
  const ACTscore = Math.round(
    (actEnglishScore + actMathScore + actReadingScore + actScienceScore) / 4
  );

  //calculate which levels to use of the test
  satVerbalLevel.current = resp[1].score >= 70 ? 1 : 0;
  satMathLevel.current = resp[6].score >= 65 ? 1 : 0;

  const satVerbalScore =
    satVerbalLevel.current === 0
      ? SATverbalScoringMatrix.easy[resp[1].correctAnswer][
          resp[3].correctAnswer
        ]
      : SATverbalScoringMatrix.easy[resp[1].correctAnswer][
          resp[4].correctAnswer
        ];
  const satMathScore =
    satMathLevel.current === 0
      ? SATmathScoringMatrix.easy[resp[6].correctAnswer][resp[8].correctAnswer]
      : SATmathScoringMatrix.easy[resp[6].correctAnswer][resp[9].correctAnswer];

  // decide which score is highest
  const satEquivalent = EqualityMatrix[ACTscore];
  let decisionTxt =
    satEquivalent > satVerbalScore + satMathScore ? "the ACT" : "the SAT";

  if (Math.abs(satEquivalent - (satVerbalScore + satMathScore)) <= 20) {
    decisionTxt = "both";
  }

  const actEnglishQuestionData = resp[0]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const actMathQuestionData = resp[2]?.questionData.map((question, index) => {
    return formatAnswerResponse(question, "ACT", index);
  });

  const actReadingQuestionData = resp[5]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const actScienceQuestionData = resp[7]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const satVerbalMod1QuestionData = resp[1]?.questionData.map((question) => {
    return formatAnswerResponse(question);
  });

  const satVerbalMod2QuestionData =
    satVerbalLevel.current === 0
      ? resp[3]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        })
      : resp[4]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        });

  const MathMod1QuestionData = resp[6]?.questionData.map((question) => {
    return formatAnswerResponse(question);
  });

  const satMathMod2QuestionData =
    satMathLevel.current === 0
      ? resp[8]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        })
      : resp[9]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        });
  //create summary table matrices
  let summary_tables = [];

  const tableIds =
    satVerbalLevel.current === 0
      ? [0, 1, 2, 3, 5, 6, 7, -1]
      : [0, 1, 2, 4, 5, 6, 7, -1];

  tableIds[7] = satMathLevel.current === 0 ? 8 : 9;

  tableIds.forEach((tableId, index) => {
    const tableCats = [];
    let table = {
      table_name: resp[tableId].sectionName,
      categories: {},
    };
    let resultData = resp[tableId];
    let isDuplicate = false;

    //combine sat math modules into 1 and verbal into 1
    if (tableId === 1) {
      resultData.questionData = [
        ...resp[tableId].questionData,
        ...resp[tableIds[3]].questionData,
      ];
      table.table_name = "SAT Reading and Writing";
    }
    if (tableId === 6) {
      resultData.questionData = [
        ...resp[tableId].questionData,
        ...resp[tableIds[7]].questionData,
      ];
      table.table_name = "SAT Math";
    }

    if (index === 3 || index === 7) isDuplicate = true;

    resultData.questionData.forEach((item) => {
      if (!tableCats.includes(item.questionCategory)) {
        tableCats.push(item.questionCategory);
        table.categories[item.questionCategory] = {
          title: item.questionCategory,
          value: 0.0,
          correct: 0,
          incorrect: 0,
          len: 0,
        };
      }
      if (item.correctAnswer === item.userAnswer) {
        table.categories[item.questionCategory].value += 1;
        table.categories[item.questionCategory].correct += 1;
      } else {
        table.categories[item.questionCategory].incorrect += 1;
      }
      table.categories[item.questionCategory].len++;
    });
    for (let key in table.categories) {
      const target = table.categories[key];
      target.value = Math.round((target.correct / target.len) * 100).toFixed(2);
    }
    if (!isDuplicate) summary_tables.push(table);
  });

  //reorder the summary tables
  const tempTables = [
    summary_tables[0],
    summary_tables[1],
    summary_tables[2],
    summary_tables[4],
    summary_tables[3],
    null,
    summary_tables[5],
  ];
  summary_tables = tempTables;

  const stats = {
    decision: decisionTxt,
    act_summary: {
      act_score: ACTscore,
      sat_score: satVerbalScore + satMathScore,
      percentile: 807,
      details: {
        english: actEnglishScore,
        math: actMathScore,
        reading: actReadingScore,
        science: actScienceScore,
      },
    },
    sat_summary: {
      act_score: ACTscore,
      sat_score: satVerbalScore + satMathScore,
      percentile: 0,
      details: {
        verbal: satVerbalScore,
        math: satMathScore,
      },
    },
    act_answers: {
      english: actEnglishQuestionData,
      math: actMathQuestionData,
      reading: actReadingQuestionData,
      science: actScienceQuestionData,
    },
    sat_answers: {
      verbal: satVerbalMod1QuestionData,
      verbal2: satVerbalMod2QuestionData,
      math: MathMod1QuestionData,
      math2: satMathMod2QuestionData,
    },
    summary_tables: summary_tables,
  };

  return stats;
};

export const questionCatDescriptions = {
  "Transitions and Directional Words":
    "Transitions and Directional Words - These questions assess students’ ability to choose the appropriate connective word or phrase that best links ideas, maintains the flow of an argument, or clarifies the relationship between concepts in a passage.",
  "Grammar and Syntax":
    "Grammar and Syntax – These questions test the grammatical and syntactically soundness of sentences.  Students should make sure each sentence is grammatically and syntactically sound. They should be mindful of parallel structure, verb tense, subject-verb agreement, pronoun agreement, pronoun ambiguity, and pronoun case, and make sure all transitions and directional words are utilized correctly. They should be wary of redundancies, and generally avoid verbosity and awkwardness.",
  Punctuation:
    "Punctuation – These questions test students’ knowledge of proper use of punctuation marks like commas, semicolons, colons, hyphens, periods, and apostrophes. Also tested in this category are comma splices and run-on sentences and sentence fragments. Students should also be mindful of how punctuation placement affects the meaning of a sentence.",
  "Rhetorical Analysis":
    "Rhetorical Analysis – these questions test students’ ability to interpret and synthesize information from a given text and critically evaluate its significance within a broader context. They require the extraction of relevant details to understand the author's purpose, assess the efficacy of their arguments, and deduce implications. These questions demand a high level of reading comprehension, analytical reasoning, and the ability to make inferences that connect the material to larger themes or historical and cultural phenomena.",
  Arithmetic:
    "Arithmetic – “Arithmetic” questions deal with number theory and pre-algebra concepts like percents, rates, and ratios.",
  Statistics:
    "Statistics – “Statistics” questions deal with statistical concepts and measurements like median, mean, mode, range, and standard deviation.  These questions will also ask students to interpret data graphs and charts, like bar graphs, scatterplots, and stem-and-leaf plots, among others.",
  "Basic Algebra":
    "Basic Algebra – “Basic Algebra” questions deal with the skills and concepts generally taught in Algebra 1, such as solving for one or two variables, graphing lines on the xy-plane, and creating linear equations from word problems.",
  "Advanced Algebra":
    "Advanced Algebra – “Advanced Algebra” questions deal with the skills and concepts generally taught in Algebra 2, such as quadratic functions, exponential functions, and function translations, among other things.",
  Geometry:
    "Geometry – “Geometry” questions deal with geometric shapes and the rules that govern them, as well as simple trigonometry usually taught in geometry classes.",
  Precalculus:
    "Precalculus – “Precalculus” questions test skills and concepts generally taught in precalculus classes, like trigonometric identities, radians, the Unit Circle, and Sine and Cosine graphs.",
  "Long Word Problems":
    "Long Word Problems – These questions test students’ ability to understand convoluted math puzzles.  They are usually longer and more dense than other math questions and test students’ reading comprehension abilities almost as much as their math skills.",
  "Main Idea":
    "Main Idea – “Main Idea” questions gauge a student's ability to identify the central theme or primary argument of a text. They test the synthesis of key points and the distillation of essential messages from details presented.",
  "Analytical Reasoning":
    "Analytical Reasoning – 'Analytical Reasoning' questions evaluate a student's capacity to logically connect ideas and evidence within a text to draw conclusions, support arguments, or extend understanding to new contexts. They test critical thinking and the ability to apply logic to analyze the implications of given information or hypotheses.",
  "Specific Questions":
    "Specific Questions – “Specific Questions” test students’ ability to remember or find specific pieces of information from the text.",
  "Vocab In Context":
    "Vocab in Context – “Vocab in Context” questions evaluate students’ proficiency in interpreting and applying vocabulary based on the surrounding text. They require students to discern nuances in word meaning, understand the connotation and denotation of terms, and select words that precisely fit the context of the passage.",
  "Data Interpretation":
    "Data Interpretation – “Data Interpretation” questions ask you to manipulate and analyze  scientific data presented in scientific tables, graphs, and diagrams (e.g., recognize trends in data, translate tabular data into graphs, interpolate and extrapolate, and reason mathematically). ",
  "Evaluation of Models, Inferences, and Experimental Results":
    "Evaluation of Models, Inferences, and Experimental Results - These questions ask you to judge the validity of scientific information and formulate conclusions and predictions based on that information (e.g., determine which explanation for a scientific phenomenon is supported by new findings).",
  "Scientific Investigation":
    "Scientific Investigation – “Scientific Investigation” questions require students to understand experimental tools, procedures, and design (e.g., identify controls and variables) and compare, extend, and modify experiments (e.g., predict the results of additional trials).",
};
